import React, {useState, useEffect, useRef, useLayoutEffect, useMapEvents, useMemo} from "react";
import {useMap} from "react-leaflet";
import FlyObjectPanelButton from "./FlyObjectPanelButton";
import Moment from 'react-moment';
import moment from 'moment';
import FlyObjectPanelButtonWindy from "./FlyObjectPanelButtonWindy";
import DeviceStatusDot from "./DeviceStatusDot";
import { sortDevicesByOnlineStatus } from "../lib/sortDevicesByOnlineStatus";


export default function ControlPanelWindy(props) {
    const [zoomLevel, setZoomLevel] = useState(1);
    //const [userAuthController, setUserAuthController] = useState(props.userAuthController);
    const [serialsList, setSerials] = useState(props.listSns);
    const [userTipo, setUserTipo] = useState(props.userTipo);
    const [iconLinkStatus, setIconLinkStatus] = useState("fa-chevron-up");
    const [styleScroll, setStyleScroll] = useState("scrollBarWindy");
    const [controlPanelLaterale2, setControlPanelLaterale2] = useState("ControlPanelLaterale2-openWindy");
    const [controlPanelLaterale2_2, setControlPanelLaterale2_2] = useState("ControlPanelLaterale2-2-openWindy");
    const [divWindowCalc, setDivWindowCalc] = useState((window.innerHeight/2)- 50);

    const deviceOnlineStatus = props.deviceOnlineStatus ?? {};

    const sortedSerialsList = useMemo(
        () => sortDevicesByOnlineStatus(serialsList, deviceOnlineStatus),
        [serialsList, deviceOnlineStatus]
    );

    let stateButton = false;

    function setZoomLevelCB(zl) {
        props.callBackSetGeneralZoomMap(zl);
        setZoomLevel(zl);
    }

    useEffect(() => {setUserTipo(props.userTipo)}, [props.userTipo])

    useEffect(() => {
        setSerials(props.listSns);
        props.setSerialsAttivi(props.listSns);

    }, [props.listSns]);
/*
    useEffect(() => {
        setUserAuthController(props.userAuthController);
    }, [props.userAuthController]);
*/
    useEffect(() => {

        //console.log("userAuth ? " + userAuthController);

        const updateDivWindowCalc = () => {
          setDivWindowCalc((window.innerHeight / 2) - 50);
          //console.log(divWindowCalc);


        if(divWindowCalc > (serialsList.length * 47) + 80){

            //console.log(divWindowCalc + ">" +  ((serialsList.length * 47) + 80) + " ?");
            //console.log("dim Window > listaCalcolata");

            const element = document.querySelector('.ControlPanelLaterale2-openWindy');
            if (element) {
            element.style.height = (serialsList.length * 47) + 80 + "px";
            }

            const element3 = document.querySelector('.ControlPanelLaterale2-1Windy');
                
            if(element3){
                element3.style.height = "40px";
            }

            const element2 = document.querySelector('.ControlPanelLaterale2-2-openWindy');

            if (element2) {
                element2.style.height = (serialsList.length * 47) + 10 + "px";
            }
        }
        else{

            //console.log(divWindowCalc + "<" +  ((serialsList.length * 47) + 80)  + " ?");
            //console.log("dim Window < listaCalcolata");


            const element = document.querySelector('.ControlPanelLaterale2-openWindy');
            
            if (element) {
                element.style.height = divWindowCalc + "px";
            }

            const element3 = document.querySelector('.ControlPanelLaterale2-1Windy');
                
            // vi aggiungo css 
            if(element3){
                element3.style.height = "40px";
            }

            const element2 = document.querySelector('.ControlPanelLaterale2-2-openWindy');

            if (element2) {
                element2.style.height = divWindowCalc - 60 + "px";
            }

        }


        };
      
        window.addEventListener('resize', updateDivWindowCalc);
      
        updateDivWindowCalc();
/*
        if(userAuthController == null){
            const controlPanelUn = document.querySelector(".ControlPanelLaterale2-unauthorized");

            controlPanelUn.style.height = "100px";
        }
  */    
        return () => {
          window.removeEventListener('resize', updateDivWindowCalc);
        };
    }, [serialsList.length, divWindowCalc/*,userAuthController*/]);

        

      const clickMenu = () => {

        if(styleScroll == "scrollBarWindy"){ 

            //console.log("styleScroll == scrollBarWindy  ::  " + styleScroll);

            const element = document.querySelector('.scrollBarWindy');
            const element3 = document.querySelector('.ControlPanelLaterale2-1Windy');
            
            // vi aggiungo css 

            element3.style.height = "40px";
            
            if (element) {
                //element.style.display = 'none';
                //element.style.pointerEvents = 'none';
              }

            setStyleScroll("scrollBarClickedWindy");

        }
        else{ //apro
            //console.log("styleScroll == scrollBarClickedWindy  ::  " + styleScroll);

            const element = document.querySelector('.scrollBarClickedWindy');
            
            const element3 = document.querySelector('.ControlPanelLaterale2-1Windy');

            element3.style.height = "40px";
            element.style.display = 'block';
            element.style.pointerEvents = 'auto';
            element.style.height = (serialsList.length * 47) + 10 + "px";

            setStyleScroll("scrollBarWindy");
            
        }

        if(controlPanelLaterale2 == "ControlPanelLaterale2-openWindy"){  // chiudo
            //console.log("controlPanelLaterale2 == ControlPanelLaterale2-open  ::  " + controlPanelLaterale2);
            
            const element = document.querySelector('.ControlPanelLaterale2-openWindy');
            const element2 = document.querySelector('.ControlPanelLaterale2-2-openWindy');

            const element3 = document.querySelector('.ControlPanelLaterale2-1Windy');
            
            element.style.height = "52px";

            element3.style.height = "40px";
            
            if(element2){
                //element2.style.display = "none";
                //element2.style.pointerEvents = 'none';
            }

            setControlPanelLaterale2("ControlPanelLaterale2-closeWindy");
            setControlPanelLaterale2_2("ControlPanelLaterale2-2-closeWindy");
            
        }
        else{ 

            if(divWindowCalc > (serialsList.length * 47) + 80){

                //console.log(divWindowCalc + ">" +  ((serialsList.length * 47) + 80) + " ?");
                //console.log("dim Window > listaCalcolata");

                const element = document.querySelector('.ControlPanelLaterale2-closeWindy');
                if (element) {
                element.style.height = (serialsList.length * 47) + 80 + "px";
                }

                const element3 = document.querySelector('.ControlPanelLaterale2-1Windy');
                    
                if(element3){
                    element3.style.height = "40px";
                }

                const element2 = document.querySelector('.ControlPanelLaterale2-2-closeWindy');

                if (element2) {
                    element2.style.height = (serialsList.length * 47) + 10 + "px";
                }
            }
            else{

                //console.log(divWindowCalc + "<" +  ((serialsList.length * 47) + 80)  + " ?");
                //console.log("dim Window < listaCalcolata");

                const element = document.querySelector('.ControlPanelLaterale2-closeWindy');
                
                if (element) {
                    element.style.height = divWindowCalc + "px";
                }

                const element3 = document.querySelector('.ControlPanelLaterale2-1Windy');
                    
                // vi aggiungo css 
                if(element3){
                    element3.style.height = "40px";
                }

                const element2 = document.querySelector('.ControlPanelLaterale2-2-closeWindy');

                if (element2) {
                    element2.style.height = divWindowCalc - 60 + "px";
                }

            }

            setControlPanelLaterale2("ControlPanelLaterale2-openWindy");
            setControlPanelLaterale2_2("ControlPanelLaterale2-2-openWindy");

                        
        }


        if(iconLinkStatus == "fa-chevron-up"){
            setIconLinkStatus("fa-chevron-down")
        }
        else{
            setIconLinkStatus("fa-chevron-up")
        }

    }

    return(
            <>
                {
                    /*userAuthController && */serialsList.length>0 ? (


                        <div className={"d-flex flex-column " + controlPanelLaterale2} /*onMouseOver={changeClick} onMouseOut={changeClick2}*/>

                            <div className="d-flex flex-row intestazioneDevicesWindy ControlPanelLaterale2-1Windy">

                                <h4 className="ControlPanelLateraleTitleWindy mr-10">Devices</h4>

                                <div className="divContainerButtSelezionaWindy">
                                    <button className="btn buttRetryControlPanelWindy" type="submit" onClick={clickMenu}>
                                        <div className={"fas " + iconLinkStatus}>
                                        </div>
                                    </button>
                                </div>

                            </div>


                            <div className={"d-flex flex-column flex-center " + controlPanelLaterale2_2}>

                                <div className={"ControlPanelLaterale2-2-1Windy " + styleScroll}>
                                    {sortedSerialsList.map((sn) => (
                                            <div className="device-panel-row" key={sn.sn}>
                                                <FlyObjectPanelButtonWindy
                                                    htkBackend={props.htkBackend}
                                                    userTipo={userTipo}
                                                    setMainFlyObject={props.setMainFlyObject}
                                                    /*stateButton={false}*/
                                                    stateButton={props.buttonStates[sn.sn] || false}
                                                    sn={sn}
                                                    cambiaButton={props.cambiaButton}
                                                />
                                                <DeviceStatusDot isOnline={deviceOnlineStatus[sn.sn]} />
                                            </div>
                                    ))}
                                </div>

                            </div>


                        </div>



                    )
                    : 
                    (
                        <div className={"d-flex flex-column ControlPanelLaterale2-unauthorized"}>
            
                            <div className="d-flex flex-row intestazioneDevices ControlPanelLaterale2-1Windy">

                                <h4 className="ControlPanelLateraleTitle mr-10">Devices</h4>

                                <div className="divContainerButtSeleziona">
                                    <button className="btn buttRetryControlPanel" type="submit">
                                        <div className={"fas fa-chevron-up"}>
                                        </div>
                                    </button>
                                </div>

                            </div>


                            <div className="d-flex flex-column ControlPanelLaterale2-2">
                                <div><i className="fad fa-circle-exclamation"></i> No authorized device for this account</div>
                            </div>

                        </div>
                    )}
            </>
        );
}
